module.exports = __webpack_public_path__ + "img/icon-sb-help-center-48x48.ea24fc3.svg";